import React from "react";
import { Route, Routes } from "react-router-dom";
import TournamentsCommentsReports from "../pages/dashboardPage/tournamentsComments/tournamentsCommentsReports/TournamentsCommentsReports";
import PreviousReports from "../pages/dashboardPage/tournamentsComments/tournamentsCommentsReports/PreviousReports";
import AllTournamentComments from "../pages/dashboardPage/tournamentsComments/allTournamentComments/AllTournamentComments";

const TournamentsCommentsNavigator = () => {
  return (
    <Routes>
      <Route
        path="/show-comments-reports"
        element={<TournamentsCommentsReports />}
      />
      <Route path="/previous-reports" element={<PreviousReports />} />
      <Route path="/all-comments" element={<AllTournamentComments />} />
      <Route path="*" element={<TournamentsCommentsReports />} />
    </Routes>
  );
};

export default TournamentsCommentsNavigator;
